import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Button } from "react-bootstrap";

const NoAccessPage = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const params = new URLSearchParams(location.search);
  const fromStateName = location?.state?.productName;
  const productName = fromStateName || params.get("product") || "this product";

  return (
    <div className="w-100 h-100 d-flex justify-content-center flex-column align-items-center">
      <div className="d-flex flex-column w-100 my-2" style={{ height: "40px", width: "100%" }} />
      <div className="d-flex flex-grow-1 flex-column bg-white rounded-4 rounded-left w-100 h-100 justify-content-center align-items-center">
        <div className="text-center px-3" style={{ maxWidth: 640 }}>
          <p className="alert alert-warning m-0 mb-3" role="alert">
            You don&apos;t have access to {productName}. <br />
            Please contact admin for more details.
          </p>
          <div className="d-flex justify-content-center gap-2 flex-wrap">
            <Button
              variant="outline-secondary"
              onClick={() => {
                window.location.href = "mailto:admin@emalpha.com";
              }}
            >
              Contact Admin
            </Button>
            <Button variant="primary" onClick={() => navigate("/pricing")}>
              Browse Plans
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NoAccessPage;

